const _ = (data: any) => {
  const products: any = [];
  const product = {
    id: `${data.manufacturerCode}  ${data.partNumber}`,
    quantity: data.returnQuantity,
    price: data.price
  };
  products.push(product);
  return products;
};

export default (data: any, event: string) => {
  const dataLayerObject = _(data);
  return {
    event,
    ecommerce: {
      refund: {
        actionField: {
          id: data.confirmationId ? data.confirmationId : data.invoiceNumber,
          revenue: data.price * data.returnQuantity
        },
        products: [...dataLayerObject]
      }
    }
  };
};
